/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */

var klaviyo = klaviyo || [];

klaviyo.init({
  account: "R3DmBr",
  platform: "shopify",
});
klaviyo.enable("backinstock",{
  trigger: {
    product_page_text: "AVÍSAME CUANDO ESTÉ DISPONIBLE",
    product_page_class: "btn",
    product_page_text_align: "center",
    product_page_margin: "0px",
    replace_anchor: false
  },
  modal: {
    headline: "{product_name}",
    body_content: "¡Anótate a la lista y te llegará un correo en cuanto volvamos a tener este producto disponible!",
    email_field_label: "Correo electrónico",
    button_label: "AVÍSAME CUANDO ESTÉ DISPONIBLE",
    subscription_success_label: "Te avisaremos cuando esté de vuelta.",
    footer_content: '',
    additional_styles: "@import url(//twinsandicons.mx/cdn/shop/t/68/assets/theme.css?v=116557150794041418651769537864); @import url(//twinsandicons.mx/cdn/shop/t/68/assets/css-klaviyo-bis.css?v=54208949089273344491769537864);",
    drop_background_color: "#000",
    background_color: "#fff",
    text_color: "#222",
    button_text_color: "#fff",
    button_background_color: "#439fdb",
    close_button_color: "#ccc",
    error_background_color: "#fcd6d7",
    error_text_color: "#C72E2F",
    success_background_color: "#d3efcd",
    success_text_color: "#1B9500",
    close_label: 'Cerrar',
  },
});

